import React, { useState } from "react";

function HeaderBranco() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full bg-white shadow-md z-50">
      <div className="container mx-auto flex items-center justify-between px-6 py-4">
        {/* Logo da empresa */}
        <a href="https://inovacodigo.com.br">
          <img 
            src="https://inovacodigo.com.br/img/nome.png" 
            alt="Logo da Empresa"
            className="h-16"
          />
        </a>

        {/* Ícone de menu hambúrguer para dispositivos móveis */}
        <button 
          className="md:hidden text-gray-900"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="block w-6 h-0.5 bg-gray-900 mb-1"></span>
          <span className="block w-6 h-0.5 bg-gray-900 mb-1"></span>
          <span className="block w-6 h-0.5 bg-gray-900"></span>
        </button>

        {/* Navegação */}
        <nav>
          <ul className={`md:flex space-x-8 items-center ${isMenuOpen ? 'block' : 'hidden'} md:block`}>
            <li>
              <a 
                href="#section-about" 
                className="text-gray-900 font-semibold uppercase hover:text-orange-500 transition duration-300 ease-in-out transform hover:scale-105"
              >
                Sobre Mim
              </a>
            </li>
            <li>
              <a 
                href="#section-solucoes" 
                className="text-gray-900 font-semibold uppercase hover:text-orange-500 transition duration-300 ease-in-out transform hover:scale-105"
              >
                Serviços
              </a>
            </li>
            <li>
              <a 
                href="#Portifolio" 
                className="text-gray-900 font-semibold uppercase hover:text-orange-500 transition duration-300 ease-in-out transform hover:scale-105"
              >
                Portfólio
              </a>
            </li>
            
            {/* Botão de contato */}
            <li>
              <a 
                href="https://wa.me/5531993018766"  target="_blank"
                className="bg-orange-500 text-white font-bold py-2 px-6 rounded-full uppercase hover:bg-orange-600 transition duration-300 ease-in-out"
              >
                Fale comigo
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default HeaderBranco;
